import {v4 as uuidv4} from "uuid";
import classNames from "classnames";

const operatorOptions = [
  {value: "", label: "select operator"},
  {value: "<", label: "<"},
  {value: "<=", label: "<="},
  {value: "==", label: "=="},
  {value: ">=", label: ">="},
  {value: ">", label: ">"},
];

const stringOperatorOptions = [
  {value: "", label: "select operator"},
  {value: '==', label: 'is'},
  {value: '!=', label: 'is not'},
  {value: 'startsWith', label: 'starts with'},
  {value: 'in', label: 'is one of'},
  {value: 'notIn', label: 'is not one of'},
]

const transactionStateOptions = [
  {value: "", label: "select state"},
  {value: "declined", label: "declined"},
  {value: "approved", label: "approved"},
  {value: "aborted", label: "aborted"},
  {value: "error", label: "error"},
];

const declinedReasonOptions = [
  {value: "", label: "select state"},
  {
    value: "Transaction declined : pick up card",
    label: "card stolen/pick up card",
  },
  {value: "Transaction declined : card lost", label: "card lost"},
  {value: "Transaction declined : limit exceeded", label: "limit exceeded"},
  {
    value: "Transaction declined : incorrect personal identification number",
    label: "incorrect PIN",
  },
  {value: "Transaction declined : invalid card", label: "invalid card"},
  {value: "Transaction declined : restricted card", label: "restricted card"},
  {
    value: "Transaction declined : amount exceeds credit",
    label: "insufficient funds",
  },
];

function triggeredAfter(parent) {
  return (
    <span>
      <input
        className="small"
        type="number"
        onChange={parent.onFieldChanged.bind(
          parent,
          "triggeredTimes",
          parseFloat
        )}
        value={parent.props.rule.triggeredTimes || 1}
      />
      &nbsp;times in the past&nbsp;
      <input
        className="small"
        type="number"
        onChange={parent.onFieldChanged.bind(
          parent,
          "triggeredHours",
          parseFloat
        )}
        value={parent.props.rule.triggeredHours || 24}
      />
      &nbsp;hours
    </span>
  );
}

function valueSelect(placeholder, options, verb = "is", fieldName = "stringOperand") {
  function inner(parent) {
    return (
      <span>
        <span> {verb} </span>
        <InlineSelect
          placeholder={placeholder}
          options={options}
          onChange={parent.onFieldChanged.bind(parent, fieldName, null)}
          value={parent.props.rule[fieldName]}
        />
      </span>
    );
  }

  return inner;
}

const placeholderMetric = {value: "", label: "please select a metric"};
const amountMetric = {value: "transactionAmount", label: "transaction amount", showDays: false};

const metricOptions = {
  uninitialized: [],
  risk_profile: [
    placeholderMetric,
    amountMetric,
    {
      value: "riskScore",
      label: "risk score",
      showDays: false,
      showCondition: true
    },
    {
      value: "sumRiskScore",
      label: "sum of risk scores",
      showDays: true,
      showCondition: true
    },
    {
      value: "countRiskAlerts",
      label: "number of risk alerts",
      showDays: true,
      showCondition: true
    },
    {value: "wasDeferred", label: "was a deferred authorisation", showDays: false, showCondition: false},
    {
      value: "isInternational",
      label: "is an international card",
      showDays: false,
      showCondition: false,
      className: "after-transaction",
    },
    {
      value: "isSwipeAndSign",
      label: "is a swipe and sign transaction ",
      showDays: false,
      showCondition: false,
      className: "after-transaction",
    },
    {
      value: "isFallback",
      label: "is a fallback transaction",
      showDays: false,
      showCondition: false,
      className: "after-transaction",
    },
    {
      value: "isCardPresent",
      label: "is a card present transaction",
      showDays: false,
      showCondition: false,
      className: "after-transaction",
    },
    {
      value: "isCardNotPresent",
      label: "is a card not present transaction",
      showDays: false,
      showCondition: false,
      className: "after-transaction",
    },
    {
      value: "isEciAuthIncomplete",
      label: "is a 3D auth incomplete transaction (ECI 06/01)",
      showDays: false,
      showCondition: false,
      className: "after-transaction",
    },
    {
      value: "transactionState",
      label: "transaction state",
      showDays: false,
      showCondition: false,
      after: valueSelect("select state", transactionStateOptions),
    },
    {
      value: "declinedReason",
      label: "declined reason",
      showDays: false,
      showCondition: false,
      after: valueSelect("select declined reason", declinedReasonOptions),
    },
    {value: "transactionsVolume", label: "transaction volume"},
    {value: "transactionsCount", label: "# of transactions"},
    {value: "swipeCount", label: "# of swipe and sign transactions"},
    {value: "swipePercent", label: "% of swipe and sign transactions"},
    {value: "swipeVolume", label: "volume of swipe and sign transactions"},
    {value: "internationCount", label: "# of international transactions"},
    {value: "internationalPercent", label: "% of international transactions"},
    {
      value: "internationalVolume",
      label: "volume of international transactions",
    },
    {value: "declinedCount", label: "# of declined transactions"},
    {value: "declinedPercent", label: "% of declined transactions"},
    {value: "declinedVolume", label: "volume of declined transactions"},
    {
      value: "binNumber",
      label: "BIN number",
      showStringOperators: true,
      showDays: false
    },
    {
      value: "repeatCardHolderCount",
      label: "# transactions with same cardholder",
      className: "after-transaction",
    },
    {
      value: "repeatBINCount",
      label: "# of transactions with same BIN",
      className: "after-transaction",
    },
    {
      value: "businessAgeMonths",
      label: "business age (months)",
      showDays: false
    },
    {
      value: "hasntTriggered",
      label: "hasn't triggered",
      showDays: false,
      showCondition: false,
      after: triggeredAfter,
    },
    {value: "eciIncompleteCount", label: "# of 3D auth incomplete (ECI 06/01) transactions"},
    {value: "eciIncompletePercent", label: "% of 3D auth incomplete (ECI 06/01) transactions"},
    {value: "eciIncompleteVolume", label: "volume of 3D auth incomplete (ECI 06/01) transactions"},
  ]
};

function delaySettlementOptions(parent) {
  return (
    <span>
      by&nbsp;
      <input
        className="small"
        type="number"
        onChange={parent.onFieldChanged.bind(parent, "delayBy", parseFloat)}
        value={parent.props.action.delayBy}
      />
      &nbsp;days
    </span>
  );
}

const actionOptions = {
  unitialized: [],
  risk_profile: [
    {value: "", label: "please select an action"},
    {value: "sendNotification", label: "generate risk alert"},
    {
      value: "delaySettlement",
      label: "delay settlement for this transaction",
      after: delaySettlementOptions,
    },
    {value: "suspendSettlement", label: "suspend all settlements for business"},
    {value: "blockTransaction", label: "block transaction"},
    {
      value: "disableTransactions",
      label: "disable future transactions for business",
    },
    {
      value: "blockSwipeAndSign",
      label: "don't allow swipe and sign for this transaction",
    },
    {
      value: "disableSwipeAndSign",
      label: "disable future swipe and sign transactions for business",
    },
  ]
};

// A value: {} looup map of our metrics
const metricMap = new Map(
  [].concat.apply([], Object.values(metricOptions)) // This is a flatten in normal JS
    .map((option) => {
      return [option.value, option];
    })
);

// A value: {} looup map of our actions
const actionMap = new Map(
  [].concat.apply([], Object.values(actionOptions)) // This is a flatten in normal JS
    .map((option) => {
      return [option.value, option];
    })
);

class InlineSelect extends waffle.base.BaseComponent {
  getSelected() {
    const value = this.getValue();
    if (value) {
      return this.props.options
        .filter((option) => option.value === value)
        .map((option) => option.label)[0];
    }

    return <span className="placeholder">{this.props.placeholder}</span>;
  }

  getValue() {
    if (this.props.value) {
      return this.props.value;
    }

    return this.props.default;
  }

  render() {
    return (
      <span className="react-textselect">
        {this.getSelected()}

        <select
          className="react-textselect-input"
          onChange={this.props.onChange}
          value={this.getValue()}
        >
          {(this.props.options || []).map((option) => {
            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </select>
      </span>
    );
  }
}

class ChildListField extends waffle.forms.FormField {
  getFieldValidators() {
    return this.fieldValidators;
  }

  onFieldChanged(fieldName, valueProcessor, event) {
    const data = Object.assign({}, this.props[this.dataPath]);

    // Some fields pass in a value, some pass in an event
    let value = null;
    if (!(event instanceof Object)) {
      value = event;
    }
    if (event && event.target !== undefined) {
      value = event.target.value;
    }

    if (valueProcessor) {
      value = valueProcessor(value);
    }

    data[fieldName] = value;

    this.props.control.onChildListFieldUpdated(data, this.parentPath);
  }

  validate() {
    const validationErrors = [];
    const fieldValidators = this.getFieldValidators();

    for (const key of Object.keys(fieldValidators)) {
      const validators = fieldValidators[key];
      for (const validator of validators) {
        const message = validator.validate(this.props[this.dataPath][key]);
        if (message) {
          validationErrors.push(message);
        }
      }
    }

    return validationErrors;
  }

  getToolbar() {
    return (
      <span className="toolbar">
        <button
          type="button"
          className="add-button"
          onClick={this.addChild.bind(this)}
        >
          AND
        </button>
        <i
          className="remove-button icon-delete-garbage-streamline text-danger"
          onClick={this.removeChild.bind(this)}
        />
      </span>
    );
  }

  removeChild() {
    this.props.control.removeChild(this.props[this.dataPath], this.parentPath);
  }

  addChild() {
    this.props.control.addChild(this.props[this.dataPath], this.parentPath);
  }
}

class ExposureRuleField extends ChildListField {
  constructor(props) {
    super(props);

    this.dataPath = "rule";
    this.parentPath = "rules";
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const metric = this.getMetric();
    const nextMetric = this.getMetric(nextProps);

    if (nextMetric && nextMetric !== metric && nextMetric.forceOperator) {
      setTimeout(() => {
        this.onFieldChanged("operator", null, nextMetric.forceOperator);
      }, 0);
    }
  }

  getFieldValidators() {
    const fieldValidators = {
      ruleMetric: [
        new waffle.forms.RequiredValidator("You must choose a metric"),
      ],
    };

    const metric = this.getMetric();

    if (metric) {
      if (metric.showCondition !== false) {
        fieldValidators.operator = [
          new waffle.forms.RequiredValidator("You must specify an operator"),
        ];

        if (metric.showStringOperators) {
          fieldValidators.value = [
            new waffle.forms.RequiredValidator("You must specify a value"),
          ];
        } else {
          fieldValidators.decimalOperand = [
            new waffle.forms.RequiredValidator("You must specify a value to compare against"),
          ];
        }
      }
      if (metric.showDays !== false) {
        fieldValidators.timePeriod = [
          new waffle.forms.RequiredValidator("You must specify a time period"),
          new waffle.forms.NumberValidator(
            false, // allowDecimal
            0, // minimumValue
            90, // maximumValue
            {
              // messages
              notNumeric: "Time period must be a number",
              belowMinimum: "Time period must be a positive number of days",
              aboveMaximum: "Time period is too long",
            }
          ),
        ];
      }
    }

    return fieldValidators;
  }

  getCondition() {
    const metric = this.getMetric();
    if (metric && metric.showCondition === false) {
      return null;
    }

    if (metric && metric.showStringOperators) {
      return (
        <span>
          <InlineSelect
            placeholder="select operator"
            options={stringOperatorOptions}
            onChange={this.onFieldChanged.bind(this, "operator", null)}
            value={this.props.rule.operator}
          />
          <input
            placeholder="X"
            className="small"
            onChange={this.onFieldChanged.bind(this, "stringOperand", null)}
            value={this.props.rule.stringOperand}
          />
        </span>
      );
    }

    return (
      <span>
        <span> is </span>
        <InlineSelect
          placeholder="select operator"
          options={operatorOptions}
          onChange={this.onFieldChanged.bind(this, "operator", null)}
          value={this.props.rule.operator}
        />
        <input
          placeholder="X"
          className="small"
          type="number"
          onChange={this.onFieldChanged.bind(this, "decimalOperand", parseFloat)}
          value={this.props.rule.decimalOperand}
        />
      </span>
    );
  }

  getMetricAfter() {
    const metric = this.getMetric();
    if (metric && metric.after) {
      return metric.after(this);
    }

    return null;
  }

  getMetric(nextProps = null) {
    if (nextProps) {
      return metricMap.get(nextProps.rule.ruleMetric);
    }

    return metricMap.get(this.props.rule.ruleMetric);
  }

  getRuleMetricSelect() {
    return (
      <InlineSelect
        options={metricOptions[this.props.exposureProfileType]}
        placeholder="select a metric"
        value={this.props.rule.ruleMetric}
        onChange={this.onFieldChanged.bind(this, "ruleMetric", null)}
      />
    );
  }

  getClassName() {
    const classes = ["exposure-rule"];
    const metric = this.getMetric();
    if (metric && metric.className) {
      classes.push(metric.className);
    }
    return classNames(classes);
  }

  getTimePeriod() {
    const metric = this.getMetric();

    if (metric && metric.showDays === false) {
      return null;
    }

    return (
      <span>
        <span> in the previous </span>
        <input
          placeholder="Y"
          className="small"
          type="number"
          onChange={this.onFieldChanged.bind(this, "timePeriod", parseInt)}
          value={this.props.rule.timePeriod}
        />
        <span> days</span>
      </span>
    );
  }

  render() {
    return (
      <span>
        <div className={this.getClassName()}>
          {this.getRuleMetricSelect()}
          {this.getCondition()}
          {this.getTimePeriod()}
          {this.getMetricAfter()}
          &nbsp;
          {this.getToolbar()}
          {this.renderHelp()}
        </div>
        {this.props.last ? "" : <label>and</label>}
      </span>
    );
  }
}

class ExposureActionField extends ChildListField {
  constructor(props) {
    super(props);

    this.dataPath = "action";
    this.parentPath = "actions";

    this.fieldValidators = {
      action: [
        new waffle.forms.RequiredValidator("You must specify an action"),
      ],
    };
  }

  getAfter() {
    const action = actionMap.get(this.props.action.action);

    if (action && action.after) {
      return action.after(this);
    }

    return null;
  }

  render() {
    return (
      <span>
        <span className="exposure-action">
          <InlineSelect
            placeholder="select an action"
            options={actionOptions[this.props.exposureProfileType]}
            value={this.props.action.action}
            onChange={this.onFieldChanged.bind(this, "action", null)}
          />
          {this.getAfter()}
          {this.renderHelp()}
          {this.getToolbar()}
        </span>
        {this.props.last ? "" : <label>and</label>}
      </span>
    );
  }
}

class ExposureControlField extends waffle.forms.FormField {
  constructor(props){
    super(props);
    this.myRef = React.createRef();
  }
  validate(forceValidation = false) {
    if (this.props.newControl && !forceValidation) {
      // If we haven't added this control, don't validate unless trying to add
      return [];
    }

    const validationErrors = [];

    const errorMap = {};
    // Validate our rules
    for (const rule of this.props.control.rules) {
      const ruleControl = this.myRef[rule.key];
      if (ruleControl) {
        const errors = ruleControl.validate();
        if (errors.length > 0) {
          errorMap[ruleControl.props.name] = errors;
        }
      }
    }

    for (const action of this.props.control.actions) {
      const actionControl = this.myRef[action.key];
      if (actionControl) {
        const errors = actionControl.validate();
        if (errors.length > 0) {
          errorMap[actionControl.props.name] = errors;
        }
      }
    }

    if (validationErrors.length > 0) {
      errorMap[this.props.name] = validationErrors;
    }

    return errorMap;
  }

  addControl() {
    this.props.form.addControl(this);
  }

  removeControl() {
    this.props.form.removeControl(this.props.control);
  }

  addChild(afterChild, dataPath) {
    const control = Object.assign({}, this.props.control);
    const index = control[dataPath].findIndex(
      (child) => child.key === afterChild.key
    );

    control[dataPath].splice(index + 1, 0, {
      key: uuidv4(),
    });
    this.props.form.onControlUpdated(control);
  }

  onChildListFieldUpdated(updatedChildField, dataPath) {
    const control = Object.assign({}, this.props.control);

    control[dataPath] = control[dataPath].map((currentField) => {
      if (currentField.key === updatedChildField.key) {
        return updatedChildField;
      }

      return currentField;
    });

    this.props.form.onControlUpdated(control);
  }

  removeChild(child, dataPath) {
    const control = Object.assign({}, this.props.control);
    control[dataPath] = control[dataPath].filter((currentChild) => {
      return currentChild.key !== child.key;
    });
    if (control[dataPath].length === 0) {
      control[dataPath].push({
        key: uuidv4(),
      });
    }
    this.props.form.onControlUpdated(control);
  }

  getActionButton() {
    if (this.props.newControl) {
      return (
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={this.addControl.bind(this)}
        >
          Add control
        </button>
      );
    } else if (this.props.control.isInherited) {
      return (
        <span className="inherited-from">
          from {this.props.control.inheritedFrom}
        </span>
      );
    }

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm"
        onClick={this.removeControl.bind(this)}
      >
        Remove control
      </button>
    );
  }

  render() {
    return (
      <div className="exposure-control">
        <div className="control-actions">{this.getActionButton()}</div>

        <label>If</label>
        {this.props.control.rules.map((rule, index) => {
          return (
            <ExposureRuleField
              exposureProfileType={this.props.exposureProfileType}
              ref={rule.key}
              key={rule.key}
              name={rule.key}
              rule={rule}
              control={this}
              last={index === this.props.control.rules.length - 1}
              validationErrors={
                this.props.form.state.validationErrors[rule.key]
              }
            />
          );
        })}
        <label>then</label>
        {this.props.control.actions.map((action, index) => {
          return (
            <ExposureActionField
              exposureProfileType={this.props.exposureProfileType}
              ref={action.key}
              key={action.key}
              name={action.key}
              action={action}
              control={this}
              last={index === this.props.control.actions.length - 1}
              validationErrors={
                this.props.form.state.validationErrors[action.key]
              }
            />
          );
        })}
        {this.renderHelp()}
      </div>
    );
  }
}

class ExposureProfileForm extends waffle.forms.Form {
  constructor(props) {
    super(props);

    this.state.newControl = this.generateNewControl();
  }

  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      editing: this.props.editing || false,
      action: this.props.action || "/api/risk/exposureProfiles/",
      hasStartedValidatingNew: false,
      data: this.props.data || {
        controls: [],
        exposureProfileType: this.props.exposureProfileType || Utils.queryParam("exposureProfileType")
      },
    });
  }

  generateNewControl() {
    return {
      key: uuidv4(),
      rules: [
        {
          key: uuidv4(),
        },
      ],
      actions: [
        {
          key: uuidv4(),
        },
      ],
    };
  }

  addControl(newControl) {
    const validationErrors = newControl.validate(true);

    if (Object.keys(validationErrors).length > 0) {
      this.setState({
        validationErrors,
        hasStartedValidatingNew: true,
      });

      return;
    }

    this.setState({
      hasStartedValidatingNew: false,
    });

    const data = this.state.data;

    const controls = this.state.data.controls;
    controls.push(newControl.props.control);
    data.controls = controls;

    this.setState({
      data,
      validationErrors: {},
      newControl: this.generateNewControl(),
    });
  }

  removeControl(control) {
    const data = this.state.data;
    data.controls = data.controls.filter((currentControl) => {
      return currentControl.key !== control.key;
    });

    this.setState({
      data,
    });
  }

  onControlUpdated(updatedControl) {
    if (this.state.newControl.key === updatedControl.key) {
      this.setState({
        newControl: updatedControl,
      });

      if (this.state.hasStartedValidatingNew) {
        setTimeout(() => {
          const control = this.myRef[updatedControl.key];
          const validationErrors = control.validate(true);

          this.setState({
            validationErrors,
            hasStartedValidatingNew: true,
          });
        }, 100);
      }
    } else {
      const data = this.state.data;
      let found = false;
      data.controls = data.controls.map((currentControl) => {
        if (currentControl.key === updatedControl.key) {
          found = true;
          return updatedControl;
        }

        return currentControl;
      });

      if (!found) {
        // This was inherited from a parent, we should move this into the child
        updatedControl.isInherited = false;
        data.controls.push(updatedControl);
      }

      this.setState({
        data,
      });

      this.revalidateIfStarted();
    }
  }

  renderHeader() {
    if (this.state.editing) {
      if (this.state.data.name) {
        return (
          <header>
            <h1>Edit '{this.state.data.name}' exposure profile</h1>
          </header>
        );
      }

      let title = "Edit exposure profile";

      if (this.state.data && this.state.data.business) {
        title = `${title} for ${this.state.data.business.displayName}`;
      }

      return (
        <header>
          <h1>{title}</h1>
        </header>
      );
    }

    return (
      <header>
        <h1>Add an exposure profile</h1>
      </header>
    );
  }

  parentChanged(value) {
    $.ajax({
      url: `/api/risk/exposureProfiles/${value}`,
    })
      .done((data) => {
        const updatedData = this.state.data;
        updatedData.parent = data.data.exposureProfile;
        updatedData.parentUUID = updatedData.parent.uuid;

        this.setState({
          data: updatedData,
        });
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        const errorMessage = Utils.errorMessage(textStatus, errorThrown);
        this.showNotification("danger", errorMessage);
      });
  }

  getProfileFields() {
    let name = null;
    if (!this.state.data.businessUUID) {
      name = (
        <waffle.forms.InputField
          name="name"
          hint="Name"
          value={this.state.data.name}
        />
      );
    }

    const api = `/api/risk/exposureProfiles/?exclude=${this.state.data.uuid}&exposureProfileType=${this.exposureProfileType()}`;

    return (
      <div>
        {name}
        <waffle.forms.SelectField
          name="exposureProfileType"
          label="Exposure Profile Type"
          options={[
            {value: "risk_profile", label: "Risk Profile"}
          ]}
        />

        <waffle.forms.SelectField
          name="parentUUID"
          label="Inherits from"
          placeholder="Please select an exposure profile"
          api={api}
          value={this.state.data.parentUUID}
          onChange={this.parentChanged.bind(this)}
        />
      </div>
    );
  }

  getControls() {
    /* Get all of our controls including those that we inherit from our parent
     * profiles
     */
    const controls = new Map();
    let current = this.state.data;

    const traversal = [current];

    while (current.parent && traversal.length) {
      traversal.push(current.parent);
      current = current.parent;
    }

    traversal.reverse();

    for (const profile of traversal) {
      for (const control of profile.controls) {
        if (profile !== this.state.data) {
          // This is a control set by a parent
          control.isInherited = true;
          control.inheritedFrom = profile.name;
        }
        controls.set(control.key, control);
      }
    }

    return Array.from(controls.values());
  }

  exposureProfileType() {
    return (this.state.data.exposureProfileType || "uninitialized");
  }

  getFields() {
    window.t = this;
    return (
      <fieldset>
        {this.getProfileFields()}

        <label>Controls</label>
        {this.getControls().map((control) => {
          return (
            <ExposureControlField
              exposureProfileType={this.exposureProfileType()}
              key={control.key}
              name={control.key}
              control={control}
            />
          );
        })}

        <hr />
        <label>Add a new control</label>

        <ExposureControlField
          exposureProfileType={this.exposureProfileType()}
          ref={this.state.newControl.key}
          key={this.state.newControl.key}
          name={this.state.newControl.key}
          newControl
          control={this.state.newControl}
        />

        <div className="actions">
          <waffle.misc.Button label="Save" />
        </div>
      </fieldset>
    );
  }

  render() {
    let businessStatus = null;
    if (this.props.businessUUID) {
      businessStatus = (
        <admin.businesses.BusinessStatusBlock
          style={{marginLeft: "0px"}}
          businessUUID={this.props.businessUUID}
        />
      );
    }

    return (
      <div className="block block-last">
        {businessStatus}
        <div className="form-block exposure-profile">{super.render()}</div>
      </div>
    );
  }

  onSuccess(data) {
    const state = {
      data: data.data.exposureProfile,
      editing: true,
      action: `/api/risk/exposureProfiles/${data.data.exposureProfile.uuid}`,
    };
    this.setState(state);
    history.pushState(
      null,
      document.title,
      `../${data.data.exposureProfile.uuid}/`
    );
  }
}

class BusinessRiskControls extends waffle.base.BaseComponent {
  getDefaultState() {
    return Object.assign(super.getDefaultState(), {
      transactionsDisabled: this.props.businessRisk.transactionsDisabled,
      swipeAndSignDisabled: this.props.businessRisk.swipeAndSignDisabled,
      transactionsAllowed: this.props.transactionsAllowed
    });
  }

  render() {
    let businessStatus = null;
    if (this.props.businessUUID) {
      businessStatus = (
        <admin.businesses.BusinessStatusBlock
          style={{marginLeft: "0px"}}
          businessUUID={this.props.businessUUID}
        />
      );
    }

    return (
      <div className="block">
        {businessStatus}
        <div className="list-block">
          <header>
            <h1>Risk controls for {this.props.businessRisk.business.displayName}</h1>
          </header>
          <waffle.buttons.ApiToggleButton
            toggled={this.state.transactionsDisabled}
            toggleOnLabel="Disable all transactions"
            toggleOnAPI={`/api/risk/businesses/${
              this.props.businessRisk.businessUUID
            }/disableTransactions`}
            toggleOnIcon="icon-credit-card"
            toggleOnClass="btn-warning"
            toggleOffLabel="Enable all transactions"
            toggleOffAPI={`/api/risk/businesses/${
              this.props.businessRisk.businessUUID
            }/enableTransactions`}
            toggleOffClass="btn-info"
            toggleOffIcon="icon-credit-card"
          />
          &nbsp;
          <waffle.buttons.ApiToggleButton
            toggled={this.state.swipeAndSignDisabled}
            toggleOnLabel="Disable swipe and sign transactions"
            toggleOnAPI={`/api/businesses/${
              this.props.businessRisk.businessUUID
            }/disableSwipeAndSign`}
            toggleOnClass="btn-warning"
            toggleOnIcon="icon-edit"
            toggleOffLabel="Enable swipe and sign transactions"
            toggleOffAPI={`/api/businesses/${
              this.props.businessRisk.businessUUID
            }/enableSwipeAndSign`}
            toggleOffClass="btn-info"
            toggleOffIcon="icon-edit"
          />
          &nbsp;
          <waffle.buttons.ApiToggleButton
            toggled={!this.state.transactionsAllowed}
            toggleOnLabel="NTUFO: Allow Transactions"
            toggleOnAPI={`/api/risk/businesses/${
              this.props.businessRisk.businessUUID
            }/ntufo/allowTransactions`}
            toggleOnIcon="icon-check-1"
            toggleOnClass="btn-info"
            toggleOffLabel="NTUFO: Block Transactions"
            toggleOffAPI={`/api/risk/businesses/${
              this.props.businessRisk.businessUUID
            }/ntufo/blockTransactions`}
            toggleOffIcon="icon-cross"
            toggleOffClass="btn-warning"
          />
        </div>
      </div>
    );
  }
}

class RiskAlert extends waffle.base.BaseComponent {
  render() {
    return (
      <div className="risk-alert">
        <waffle.misc.SlackMessage>
          {this.props.riskAlert.message}
        </waffle.misc.SlackMessage>
      </div>
    );
  }
}

class TransactionRiskBlock extends waffle.base.BaseComponent {
  render() {
    const delayAPI = `/api/transactions/${
      this.props.transactionUUID
    }/delaySettlement`;
    const allowImmediateAPI = `/api/transactions/${
      this.props.transactionUUID
    }/allowImmediateSettlement`;

    return (
      <div>
        <div className="block">
          <header>
            <h1>Transaction Risk</h1>
          </header>
          <waffle.buttons.ApiButton
            api={delayAPI}
            label="Delay settlement by 7 days"
            buttonClass="btn-warning"
          />
          &nbsp;
          <waffle.buttons.ApiButton
            api={allowImmediateAPI}
            label="Allow immediate settlement"
          />
        </div>

        <div className="block">
          <waffle.tables.InlineTable
            rows={this.props.riskAlerts.map((riskAlert) => {
              return (
                <waffle.misc.SlackMessage>
                  {riskAlert.message}
                </waffle.misc.SlackMessage>
              );
            })}
            titles={["Risk Alerts"]}
          />
        </div>
      </div>
    );
  }
}

class FraudInvestigationsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        { this.props.businessUUID ? null : (
          <waffle.filters.BusinessApiFilter />
        )}
        <waffle.filters.EnumFilter
          enumName='yoco.admin.types.TicketStatus'
          filterKey="status"
          emptySelectedString="All Statuses"
          defaults={this.props.defaultStatusFilter}
          allowSelectMultiple={true}
        />
        <waffle.filters.EnumFilter
          enumName='models.risk.FraudCategory'
          filterKey='fraudCategory'
          emptySelectedString="All Fraud Categories"
        />
        <waffle.filters.EnumFilter
          enumName='models.risk.RiskInvestigationResult'
          filterKey="result"
          emptySelectedString="All Results"
        />
        <waffle.filters.UserApiFilter
          filterKey="assignedUserUUID"
        />
      </waffle.blocks.FilterBlock>
    )
  }
}


class FraudAlertsFilterBlock extends waffle.base.BaseComponent {
  render() {
    return (
      <waffle.blocks.FilterBlock>
        { this.props.businessUUID ? null : (
          <waffle.filters.BusinessApiFilter />
        )}
        <waffle.filters.EnumFilter
          enumName='models.risk.AlertLevel'
          filterKey='alertLevel'
          emptySelectedString="All Alert Levels"
        />
        <waffle.filters.EnumFilter
          enumName='yoco.admin.types.TicketStatus'
          filterKey="status"
          emptySelectedString="All Statuses"
          allowSelectMultiple={true}
          defaults={this.props.defaultStatusFilter}
        />
        <waffle.filters.UserApiFilter
          filterKey="assignedUserUUID"
        />
        <waffle.filters.EnumFilter
          enumName='models.transaction.PaymentChannel'
          filterKey="paymentChannel"
          emptySelectedString="All Payment channels"
        />
        <waffle.filters.EnumFilter
          enumName='models.transaction.PaymentProduct'
          filterKey="paymentProduct"
          emptySelectedString="All Payment Products"
        />
      </waffle.blocks.FilterBlock>
    )
  }
}

module.exports = {
  ExposureProfileForm,
  ExposureControlField,
  BusinessRiskControls,
  TransactionRiskBlock,
  FraudInvestigationsFilterBlock,
  FraudAlertsFilterBlock
};
